module.exports = __webpack_public_path__ + "media/images/top-border-28a6b455f4be4cb0072c642dca090ba8.svg";